import "es6-promise/auto";
import Vue from "vue";
import Axios from "axios";
import Common from "../components/common.js";
import GlobalMenu from "../components/menu.vue";
import CompPager from "../components/paging.vue";

Vue.component(GlobalMenu.name, GlobalMenu);
Vue.component("common", Common);
Vue.component("pager", CompPager);

new Vue({
  el: "#scope-board",
  data: function() {
    return {
      bbsContentViewModel: {
        listBBS: [],
        detailContent: { bbs_id: "" },
        listCategory: []
      },
      isMulti: false,
      selBbsId: "",
      pager: {
        model: {},
        pageNo: 1,
        totalSize: 0,
        rowSize: 6,
        blockSize: 5,
        list: [],
        callBack: function(n) {
          this.model.fnInit(null);
        }
      },
      category: "",
      bbs_id: "",
      qnaContent: {},
      listYear: [],
      set_year: "",
      msnry: null,
      type: "",
      detailPortfolio: {}
    };
  },
  created() {
    let vm = this;
    const path = window.location.pathname;
    const segments = path.split("/");
    const bbsId = segments[segments.length - 1];
    vm.category = bbsId;
  },
  mounted: function() {
    console.log("mounted");
    let vm = this;
    try {
      if (vm.category !== "qna") {
        this.fnInit();
      }
      window.addEventListener("resize", () => {
        if (this.msnry) {
          this.msnry.layout();
        }
      });
    } catch (e) {
      console.log(e);
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler);
    if (this.msnry) this.msnry.destroy();
  },
  methods: {
    fnInit: function() {
      let vm = this;
      if (vm.category === "performance") {
        vm.bbs_id = "GHCNT_PERFORMANCE";
        vm.fnListYear();
      } else if (vm.category === "notice") {
        vm.bbs_id = "GHCNT_NOTICE";
      } else if (vm.category === "portfolio") {
        vm.bbs_id = "GHCNT_PERFORMANCE";
        vm.type = "P";
      } else if (vm.category === "incruit") {
        vm.bbs_id = "GHCNT_INCRUIT";
      } else {
        vm.bbs_id = "GHCNT_BOARD";
      }
      Axios.post("/uz/bbs/list", {
        bbsVo: { bbs_id: vm.bbs_id, set_year: vm.set_year, type: vm.type },
        pageNo: vm.pager.pageNo,
        pageSize: vm.pager.rowSize
      })
        .then(function(response) {
          let rs = response.data;
          vm.bbsContentViewModel.listBBS = rs.listBoard;
          vm.pager.totalSize = rs.totalCount;
          vm.pager.pageNum =
            vm.pager.pageNo * vm.pager.rowSize - vm.pager.rowSize;
          CompPager.props = CompPager.methods.createPaging(
            vm.pager,
            vm,
            "list"
          );

          //msnry 재배치
          vm.$nextTick(() => {
            const grid = document.querySelector(".portfolio-wrap");
            imagesLoaded(grid, () => {
              if (vm.msnry) {
                vm.msnry.destroy();
              }
              vm.msnry = new Masonry(grid, {
                itemSelector: ".masonry-item",
                percentPosition: true
              });
            });
          });
        })
        .catch(function(ex) {
          console.log(ex);
        });
    },
    fnListYear: function() {
      let vm = this;
      Axios.post("/uz/bbs/list/year", {})
        .then(function(response) {
          let rs = response.data;
          vm.listYear = rs.listYear;
        })
        .catch(function(ex) {
          console.log(ex);
        });
    },
    fnQnaCreate: function() {
      let vm = this;
      if (
        vm.qnaContent.company_name === null ||
        vm.qnaContent.company_name === ""
      ) {
        alert("회사명을 입력해 주세요.");
        return;
      }
      if (vm.qnaContent.applicant === null || vm.qnaContent.applicant === "") {
        alert("신청인 이름을 입력해 주세요.");
        return;
      }
      if (vm.qnaContent.phone === null || vm.qnaContent.phone === "") {
        alert("연락처를 입력해 주세요.");
        return;
      }
      if (vm.qnaContent.email === null || vm.qnaContent.email === "") {
        alert("이메일을 입력해 주세요.");
        return;
      }
      if (vm.qnaContent.inq_cont === null || vm.qnaContent.inq_cont === "") {
        alert("문의 내용을 입력해 주세요.");
        return;
      }
      Axios.post("/uz/qna/create", { bbsVo: vm.qnaContent })
        .then(function(response) {
          let rs = response.data;
          if (rs.resultCount > 0) {
            alert("등록 완료");
            vm.qnaContent = {};
          } else {
            alert("등록 실패");
          }
        })
        .catch(function(ex) {
          console.log(ex);
        });
    },
    fnSetYear: function(item) {
      let vm = this;
      vm.set_year = item;
      vm.pager.pageNo = 1;
      vm.fnInit();
    },
    fnOpenModal: function(item) {
      let vm = this;
      vm.detailPortfolio = item;
      console.log(item);
      const modalElement = document.getElementById("large-Modal");
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }
});



// WEBPACK FOOTER //
// ./src/gumhocnt/board-controller.js